<template>
  <article class="contents-content">
    <div class="contents-content__content">
      <div class="content-in-area">
        <h1 class="content__title with--button">공지 관리
          <v-btn v-if="$store.state.userInfo" depressed rounded outlined color="secondary" class="ml-5" @click="setCreateMode">
            <v-icon>add</v-icon> 공지 추가
          </v-btn>
        </h1>
        <v-container>
          <v-row>
            <nav class="content-left-menu" style="width: 200px">
              <div style="display: flex">
                <v-btn @click="fetchAnnouncementsPageMinus">
                  <v-icon>remove</v-icon>
                </v-btn>
                <div class="mt-1 me-3 ms-3">{{ page + 1 }} / {{ totalPages }}</div>
                <v-btn @click="fetchAnnouncementsPagePlus">
                  <v-icon>add</v-icon>
                </v-btn>
              </div>
              <transition name="fade">
                <div v-if="announcements && announcements.length > 0">
                  <ul
                    class="content-menu-list"
                    ref="contentMenu"
                  >
                    <li
                      v-for="(announcement, idx) in announcements"
                      :key="idx"
                      :class="['content-menu__item', {'is--active' : activeIndex === idx}]"
                      @click="setCurrentAnnouncement(announcement)"
                    >
                      <strong
                        class="menu__item-main"
                        style="display: flex; flex-direction: column"
                        @click="selectMainItem(idx)"
                      >
                        <div>
                          [ID] {{ announcement.id }}, [Num] {{ announcement.number }}
                        </div>
                        <div>
                          {{ announcement.title.substring(0, Math.min(10, announcement.title.length)) }}
                          <v-icon v-if="announcement.visible === false">visibility_off</v-icon>
                        </div>
                      </strong>
                    </li>
                  </ul>
                </div>
                <p class="content--empty" v-if="announcements && announcements.length === 0">등록된 공지가 없습니다.</p>
              </transition>
            </nav>
            <div class="content--has-menu" style="flex: 1">
              <v-card outlined class="content__content">
                <v-card-text>
                  <v-form
                    ref="form"
                    v-model="valid"
                    v-if="announcement && announcement.id && announcement.id !== -1 || mode === 'CREATE'"
                  >
                    <v-container>
                      <v-row class="pa-2">
                        <v-col cols="10" class="pa-0">
                          <div style="display: flex">
                            <v-text-field
                              v-model="announcement.id"
                              class="pa-0 pt-0 mr-3"
                              label="Database ID"
                              readonly='readonly'
                              required />
                            <v-text-field
                              v-model="announcement.number"
                              class="pa-0 pt-0"
                              label="표시 순서"
                              required
                              type="number" />
                          </div>
                        </v-col>
                        <v-col cols="10" class="pa-0">
                          <div style="display: flex">
                            <v-text-field
                              class="mr-3"
                              v-model="announcement.title"
                              name="input-10-2"
                              label="제목" />
                            <v-text-field
                              v-model="announcement.author"
                              name="input-10-2"
                              label="작성자" />
                          </div>
                        </v-col>
                        <v-col cols="10" class="pa-0">
                          <v-text-field
                            v-model="announcement.body"
                            label="알림 내용" />
                        </v-col>
                        <v-col cols="10" class="pa-0">
                          <v-textarea
                            v-model="announcement.content"
                            label="공지 내용" />
                        </v-col>
                        <v-col cols="10" class="pa-0">
                          <v-text-field
                            v-model="announcement.link"
                            name="input-10-2"
                            label="참조 링크" />
                        </v-col>
                        <v-col cols="10" class="pa-0">
                        </v-col>
                        <v-col cols="10" class="pa-0">
                          <div style="display: flex">
                            <v-text-field
                              v-model="announcement.date"
                              name="input-10-2"
                              label="표시 날짜" />
                            <div style="display: block">
                              <div style="font-size: small">생성날짜: {{ announcement.created }}</div>
                              <div style="font-size: small">수정날짜: {{ announcement.updated }}</div>
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="10" class="pa-0">
                          <v-checkbox
                            v-model="announcement.visible"
                            label="앱에 보이기" />
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col class="text-center mb-2">
                          <v-btn
                            v-if="$store.state.userInfo && $store.state.userInfo.readWeekly"
                            :disabled="!valid"
                            color="primary"
                            class="mt-4"
                            @click="onSummitAnnouncement"
                            rounded
                            depressed
                            large
                          >
                            {{ mode === 'CREATE' ? '생성하기' : '수정하기' }}
                          </v-btn>
                        </v-col>
                        <v-col class="text-center mb-2"  v-if="mode === 'UPDATE'">
                          <v-btn
                            v-if="$store.state.userInfo && $store.state.userInfo.readWeekly && announcement.id"
                            color="blue"
                            depressed
                            rounded
                            outlined
                            dark
                            @click="onPushAnnouncement">
                            푸시전송
                          </v-btn>
                        </v-col>
                        <v-col class="text-center mb-2"  v-if="mode === 'UPDATE'">
                          <v-btn
                            v-if="$store.state.userInfo && $store.state.userInfo.readWeekly && announcement.id"
                            color="error"
                            depressed
                            rounded
                            outlined
                            dark
                            @click="onRemoveAnnouncement">
                            공지제거
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                  <p v-else class="content--empty">선택된 공지가 없습니다.</p>
                </v-card-text>
              </v-card>
            </div>
            <div class="ml-5" style="width: 300px; display: flex; flex-direction: column;">
              <announcement-alert
                :title="this.announcement.title"
                :body="this.announcement.body"
              />
              <div class="mt-2 mb-1" style="align-items: flex-end; display: flex; justify-content: space-between">
                <span  style="color: black; font-size: small">
                  Mobile 화면
                </span>
              </div>
              <div style="flex-grow: 1; flex-direction: column; display: flex; background-color: #555555; border-radius: 15px;">
                <div class="ma-3"
                  style="flex-grow: 1; flex-direction: column; display: flex; background-color: white; border-radius: 5px;">
                  <div style="align-items: center; display: flex; height: 40px">
                    <v-icon style="height: 30px; width: 30px">arrow_back</v-icon>
                    <div style="font-size: medium; color: black">공지 보기</div>
                  </div>
                  <div style="height: 1px; background-color: #e0e0e0"></div>
                  <announcement-mobile
                    :title="this.announcement.title"
                    :content="this.announcement.content"
                    :link="this.announcement.link"
                    :date="this.announcement.date"
                    :author="this.announcement.author"
                    :darkMode="false"
                    style="flex-grow: 1; box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);"/>
                </div>
              </div>
            </div>
          </v-row>
        </v-container>
      </div>
    </div>
  </article>
</template>

<script>
import { announcement } from '@/api'
import eventBus from '../utils/eventBus'
import AnnouncementMobile from '@/views/AnnouncementMobile'
import AnnouncementAlert from '@/views/AnnouncementAlert'

export default {
  components: {
    AnnouncementAlert,
    AnnouncementMobile
  },
  data: () => ({
    announcements: null,
    page: 0,
    totalPages: 1,
    announcement_body: '',
    announcement: {
      id: -1,
      visible: true,
      number: -1,
      type: 'TEXT',
      title: '',
      body: '',
      content: '',
      link: '',
      pushAlarm: false,
      date: '',
      author: '',
      created: '',
      updated: ''
    },
    mode: null,
    valid: true,
    activeIndex: null
  }),
  created () {
    this.fetchAnnouncements()
  },
  methods: {
    setInitialMode () {
      this.announcement = {
        id: -1,
        visible: true,
        number: -1,
        type: 'TEXT',
        title: '',
        body: '',
        content: '',
        link: '',
        pushAlarm: false,
        date: '',
        author: '',
        created: '',
        updated: ''
      }
      this.mode = 'null'
      this.activeIndex = null
    },
    setCreateMode () {
      this.announcement = {
        id: -1,
        visible: true,
        number: -1,
        type: 'TEXT',
        title: '',
        body: '',
        content: '',
        link: '',
        pushAlarm: false,
        date: this.getFormattedDate(),
        author: this.$store.state.userInfo.name,
        created: '(자동 생성)',
        updated: '(자동 생성)'
      }
      this.mode = 'CREATE'
      this.activeIndex = null
    },
    async setCurrentAnnouncement (item) {
      const { data } = await announcement.get(item.id)
      this.announcement = data
      this.mode = 'UPDATE'
    },
    async fetchAnnouncementsPagePlus () {
      this.page++
      if (this.totalPages <= this.page) {
        this.page = this.totalPages - 1
      }
      await this.fetchAnnouncements()
    },
    async fetchAnnouncementsPageMinus () {
      this.page--
      if (this.page <= 0) {
        this.page = 0
      }
      await this.fetchAnnouncements()
    },
    async fetchAnnouncements () {
      const { data } = await announcement.list(this.page, 10)
      this.totalPages = data.totalPages
      this.announcements = data.content
      console.log(this.announcements)
    },
    async updateAnnouncement () {
      try {
        eventBus.$emit('showLoading')
        await announcement.set(this.announcement.id, {
          ...this.announcement
        })
        await this.fetchAnnouncements()
        eventBus.$emit('alert', { active: true, text: '수정 되었습니다.' })
      } catch (e) {
        eventBus.$emit('alert', { active: true, text: '에러' + e.text })
      } finally {
        eventBus.$emit('hideLoading')
      }
    },
    async createAnnouncement () {
      try {
        eventBus.$emit('showLoading')
        const { data } = await announcement.create({
          ...this.announcement
        })
        eventBus.$emit('alert', { active: true, text: '생성 되었습니다.' })
        await this.fetchAnnouncements()
        this.setInitialMode()
      } catch (e) {
        eventBus.$emit('alert', { active: true, text: '에러 : ' + e.text + e.text })
      } finally {
        eventBus.$emit('hideLoading')
      }
    },
    async sendAnnouncement () {
      try {
        eventBus.$emit('showLoading')
        await announcement.set(this.announcement.id, {
          id: this.announcement.id,
          pushAlarm: true
        })
        eventBus.$emit('alert', { active: true, text: '푸시가 전달되었습니다.' })
      } catch (e) {
        eventBus.$emit('alert', { active: true, text: '에러 : ' + e.text })
      } finally {
        eventBus.$emit('hideLoading')
      }
    },
    async onRemoveConfirm () {
      try {
        eventBus.$emit('showLoading')
        await announcement.delete(this.announcement.id)
        eventBus.$emit('alert', { active: true, text: '제거되었습니다.' })
        this.setInitialMode()
        await this.fetchAnnouncements()
      } catch (e) {
        eventBus.$emit('alert', { active: true, text: '에러 : ' + e.text })
      } finally {
        eventBus.$emit('hideLoading')
      }
    },
    onSummitAnnouncement () {
      if (this.mode === 'CREATE') {
        this.onCreateAnnouncement()
      } else {
        this.onUpdateAnnouncement()
      }
    },
    onCreateAnnouncement () {
      eventBus.$emit('dialog',
        {
          active: true,
          msg: '공지를 생성하시겠습니까? 푸시는 전달되지 않습니다',
          okText: '생성',
          confirmHandler: {
            ok: () => {
              this.createAnnouncement()
            }
          }
        }
      )
    },
    onUpdateAnnouncement () {
      eventBus.$emit('dialog',
        {
          active: true,
          msg: '공지를 수정하시겠습니까? 푸시는 전달되지 않습니다',
          okText: '수정',
          confirmHandler: {
            ok: () => {
              this.updateAnnouncement()
            }
          }
        }
      )
    },
    onPushAnnouncement () {
      eventBus.$emit('dialog',
        {
          active: true,
          msg: '정말 푸시를 전달 하시겠습니까? 모든 성도에게 전달 됩니다',
          okText: '공지 푸시',
          confirmHandler: {
            ok: () => {
              this.sendAnnouncement()
            }
          }
        }
      )
    },
    onRemoveAnnouncement () {
      eventBus.$emit('dialog',
        {
          active: true,
          msg: '공지를 정말 제거하시겠습니까?',
          okText: '공지 제거',
          confirmHandler: {
            ok: () => {
              this.onRemoveConfirm()
            }
          }
        }
      )
    },
    getFormattedDate () {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0') // 월은 0부터 시작하므로 1을 더해준 후, 두 자리로 패딩
      const day = String(today.getDate()).padStart(2, '0') // 일자를 두 자리로 패딩
      return `${year}-${month}-${day}`
    },
    selectMainItem (index) {
      this.activeIndex = index
    }
  }
}
</script>

<style lang="scss">
</style>
